import { deleteEntity, postEntity, putEntity, getEntities, patchEntity } from './axiosSupport'
import { fetchFromLocalStorage } from 'store'
import config from 'services/config'
import { merge } from 'lodash'

export const getCurrentMemberId = () => fetchFromLocalStorage('userId', 0)
const toAesirURL = (url) => `${config.aesirUrl}/api/${url}`.replace(/\/$/, '')
const toMemberURL = (url) => toAesirURL(`users/${getCurrentMemberId()}/${url}`)

export function applyLoggedInValidationToConfig (config = {}) {
    return merge(config, {
        validateLoggedIn: true
    })
}

export async function postToAesir (url, item, requireLoggedIn = true, config = {}) {
    if (requireLoggedIn) {
        applyLoggedInValidationToConfig(config)
    }
    return postEntity(toMemberURL(url), item, config)
}

export async function postToAesirWithoutMember (url, item, config = {}) {
    return postEntity(toAesirURL(url), item, config)
}

export async function patchToAesir (url, item, requireLoggedIn = true, config = {}) {
    if (requireLoggedIn) {
        applyLoggedInValidationToConfig(config)
    }
    return patchEntity(toMemberURL(url), item, config)
}

export async function putToAesir (url, item, requireLoggedIn = true, config = {}) {
    if (requireLoggedIn) {
        applyLoggedInValidationToConfig(config)
    }
    return putEntity(toMemberURL(url), item, config)
}

export async function deleteFromAesir (url, requireLoggedIn = true, config = {}) {
    if (requireLoggedIn) {
        applyLoggedInValidationToConfig(config)
    }
    return deleteEntity(toMemberURL(url), config)
}

export async function loadFromAesir (url, requireLoggedIn = true, config = {}) {
    try {
        if (requireLoggedIn) {
            applyLoggedInValidationToConfig(config)
        }
        return await getEntities(toMemberURL(url), config)
    } catch (err) {
        throw err
    }
}

export async function loadFromAesirWithoutMember (url) {
    try {
        return await getEntities(toAesirURL(url))
    } catch (err) {
        throw err
    }
}
